<template lang="html">
	<nav id="navigation" @mousemove="loadSubmenu = true">
		<!-- {{data}} -->
		<div class="mobile-opener" ref='opener' @click='openMobile()'>
			<div class='word'>Меню</div>
			<div class='lines'>
				<span class='one'></span>
				<span class='two'></span>
				<span class='three'></span>
			</div>
		</div>

		<div class="overlay" @click='overlayClick()'></div>
		<ul>
			<template v-for='(item1, i) in items'>
				<!-- первый уро,вень меню -->
				<template v-if="i < widthDocum">
					<li @mouseenter='over1($event)'
							@mouseleave='out1($event)'>
						<template v-if='item1.submenu'>
							<a @click.self='click1($event)' :href="item1.href"><i>{{ item1.text }}</i></a>

							<div class="menuWrapAbsolut js-container">
								<div class="menuWrapRelative ulNext perfectScroll">
									<ul @click.self='ulClick'>
										<li v-if="isMobile"
												@click="backMenu($event)"
												class="backM">{{data.backText.text}}</li>
										<li v-if="loadSubmenu"
												v-for='(item2, i) in item1.submenu'
												@mouseenter.self='over2($event)'
												@mouseleave.self='out2($event)'
												:class="item2.submenu ? 'addArr' : ''"
												:style='{"animation-delay": (10 + (i*i*i)) + "ms"}'
												>
											<!-- второй уровень меню, подменю -->
											<template v-if='item2.submenu'>
												<span :class='item2.active ? "active" : false' @click.self='click1($event)'><i>{{ item2.text }}</i></span>

												<div class="wrLevel3Abs perfectScroll ulNext js-container">
													<ul>
														<li @click="backMenu" class="backM">{{data.backText.text}}</li>
														<li v-for='item3 in item2.submenu'
																:class="item3.submenu ? 'addArr' : ''">
															<!-- третий уровень меню -->
															<template v-if='item3.submenu'>
																<span :class='item3.active ? "active" : false' @click.self='click1($event)'><i>{{ item3.text }}</i></span>

																<div class="wrLevel4Abs perfectScroll ulNext js-container">
																	<ul>
																		<li @click="backMenu" class="backM">{{data.backText.text}}</li>
																		<li v-for="item4 in item3.submenu"
																				:class="item4.submenu ? 'addArr' : ''">
																			<!-- четвертый уровень -->

																			<a :class='item4.active ? "active" : false'  :href='item4.href'>
																				<span>{{ item4.text }}</span>
																			</a>
																		</li>
																	</ul>
																</div>
															</template>
															<a :class='item3.active ? "active" : false' v-else @click.self='click1($event)' :href='item3.href'>
																<span>{{ item3.text }}</span>
															</a>
														</li>
													</ul>
												</div>
											</template>

											<a :class='item2.active ? "active" : false' v-else
													:href='item2.href'>
												<i>{{ item2.text }}</i>
											</a>
										</li>
										<li v-if="data.button" class="buttonWrapper">
											<a :href="data.button.href">{{data.button.text}}</a>
										</li>
									</ul>
								</div>
							</div>
						</template>

						<a :class='item1.active ? "active" : false'
								v-else
								:href='item1.href'>
							<i>{{ item1.text }}</i>
						</a>
					</li>
				</template>
			</template>

			<!-- меню гамбургер -->
			<template v-if="items.length > widthDocum">{{items.lenght}}
				<li class="extraMenu">
					<span @click="clickExtraMenu" class="dropMenu">
						<svg :class='submenuOpened ? "animSVG" : ""' class="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<line x1="3" y1="12" x2="21" y2="12"></line>
							<line x1="3" y1="6" x2="21" y2="6"></line>
							<line x1="3" y1="18" x2="21" y2="18"></line>
						</svg>
					</span>

					<ul :class='submenuOpened ? "grid s_1 active" : "grid s_1"'>
						<template v-for='(item1, i) in items'>
							<template v-if="i >= widthDocum">
								<li>
									<a :href='item1.href'
											:class='item1.active ? "active" : false'>{{ item1.text }}</a>
								</li>
							</template>
						</template>
					</ul>
				</li>
			</template>
		</ul>
	</nav>
</template>

<script>
exports.default = {
	// this.ww < 1920 && this.ww > 1180
	props: ['data'],

	computed: {
		items() {
			return this.data.menu ? this.data.menu : [];
		},
		widthDocum() {
			if(this.ww > 1919) {
				return 7;
			} else if (this.ww > 1179 ) {
				return 7;
			} else if (this.ww > 1020 ) {
				return 7;
			} else if (this.ww > 700) {
				return 5;
			}    else if (this.ww > 640) {
				return 5;
			}  else if (this.ww < 640) {
				return 50000;
			}
			else {
				return 4;
			}

		}
		// button() {
		// 	return this.data.button ? this.data.button : {};
		// },
		//
		// phone() {
		// 	return this.data.phone ? this.data.phone : {};
		// },
		//
		// phoneWithoutSpaces() {
		// 	return `${this.phone.operator}${this.phone.number}`.replace(/\s/g, "");
		// }
	},

	data() {
		return {
			// перевірка, яку менюху треба показать - мобільну чи десктопну
			isMobile: $(window).width() > 639 ? false : true,


			// отображение меню
			ww: $(window).width(),
			medium: "",

			loadSubmenu: false,

			menuOpen: false,

			// таймаути для закривання десктопної менюшки
			timeout: {
				obj1: null,
				obj2: null,
				ms: 500
			},

			submenuOpened: false,
			countClick: 0
		}
	},

	methods: {
		// клік на елементі, який відкриває/закриває мобільне меню
		openMobile(e) {
			if(this.menuOpen) {
				$(this.$el).find('> ul').removeClass('visible');
				$(this.$el).find('.overlay').removeClass('visible');
				$(this.$refs.opener).removeClass('active');
				this.menuOpen = false;
			}
			else {
				$(this.$el).find('> ul').addClass('visible');
				$(this.$el).find('.overlay').addClass('visible');
				$(this.$refs.opener).addClass('active');
				this.menuOpen = true;
			}
		},

		overlayClick() {
			$(this.$el).find('> ul').removeClass('visible');
			$(this.$el).find('.overlay').removeClass('visible');
			$(this.$refs.opener).removeClass('active');
		},

		// клік на улку другого рівня
		ulClick() {
			if(!this.isMobile) {
				$(this.$el).find('> ul > li > ul').removeClass('visible');
			}
		},

		backMenu(e){
			// console.log($(e.target));
			$(e.target).closest('.js-container').removeClass('visible').closest('li').removeClass('opened');
			$(e.target).closest('.js-container').find('.animation').removeClass('animation');
		},


		// курсор прийшов на пункт першого рівня
		over1(e) {
			if(!this.isMobile) {
				clearTimeout(this.timeout.obj1);
				$(this.$el).find('.menuWrapAbsolut').removeClass('visible');
				$(e.target).find('.menuWrapAbsolut').addClass('visible');
				setTimeout(() => {
					$('.perfectScroll').scrollTop(1);
					$('.perfectScroll').scrollTop(0);
				}, 500);
			}
		},

		// курсор пішов з пункту першого рівня
		out1(e) {
			if(!this.isMobile) {
				this.timeout.obj1 = setTimeout(() => {
					$(e.target).find('.menuWrapAbsolut').removeClass('visible');
					$('.menuWrapAbsolut *').removeClass('visible');
					$('.menuWrapAbsolut *').removeClass('opened');
					// $('.menuWrapRelative .js-container').slideUp(0);
				}, this.timeout.ms)
				this.countClick = 0
			}
		},

		// клік на пункт першого рівня
		click1(e) {
			this.loadSubmenu = true;
			// console.log($(e.target).parent().find('>.js-container'));
			if($(e.target).parent().hasClass('opened')) {
				// $(e.target).closest('.visible').find('.animation').removeClass('animation');
				$(e.target).closest('li').find('>.js-container').removeClass('visible');
				$(e.target).parent().removeClass('opened');
			}else {
				$(e.target).closest('li').find('>.js-container').addClass('visible');
				setTimeout(() => {
					$('.perfectScroll').scrollTop(1);
					$('.perfectScroll').scrollTop(0);
				}, 800);
				// if($(e.target).siblings('.menuWrapAbsolut').length){
				// 	console.log('1');
				// 	$(e.target).closest('li').find('>.js-container > .ulNext > ul > li').each(function () {
				// 		let _this = $(this);
				// 		setTimeout(function () {
				// 			console.log('1');
				// 			_this.addClass('animation');
				// 		}, 500);
				// 	});
				// }else {
				// 	console.log('2');
				// 	$(e.target).closest('li').find('>.js-container > ul > li').each(function () {
				// 		let _this = $(this);
				// 		setTimeout(function () {
				// 			console.log('2');
				// 			_this.addClass('animation');
				// 		}, 500);
				// 	});
				// }
				$(e.target).parent().addClass('opened');
			}
			//переход по ссылке двойной клик
			this.countClick++;
			if(this.countClick <2){
				e.preventDefault();
			}
		},

		// курсор прийшов на пункт другого рівня
		over2(e) {
			clearTimeout(this.timeout.obj2);
			$(this.$el).find('> ul > li > ul > li > ul').removeClass('visible');
			$(e.target).find('> ul').addClass('visible');
		},

		// курсор пішов з пункту другого рівня
		out2(e) {
			this.timeout.obj2 = setTimeout(() => {
				$(e.target).find('> ul').removeClass('visible');
			}, this.timeout.ms)
		},

		// клік на пункт другого рівня
		// click2(e) {
		// 	console.log($(e.target));
		// 	if(this.isMobile) {
		// 		if($(e.target).hasClass('opened')) {
		// 			$(e.target).parent().find('> ul').slideUp(200, () => {
		// 				$(e.target).removeClass('opened')
		// 				// console.log($(e.target).parent().parent().parent());
		// 				$('body, html').stop().animate({
		// 					scrollTop: $(e.target).parent().parent().parent().closest('li').offset().top
		// 				}, 200)
		// 			})
		// 		}
		// 		else {
		// 			$(this.$el).find('.menuWrapAbsolut').slideUp(200, function() {
		// 				$(this).parent().find('span').removeClass('opened')
		// 			})
    //
		// 			$(e.target).parent().find('> ul').slideDown(200, function() {
		// 				$(e.target).addClass('opened')
    //
		// 				$('body, html').stop().animate({
		// 					scrollTop: $(e.target).offset().top
		// 				}, 200)
		// 			})
		// 		}
		// 	}
		// },
		clickExtraMenu(e){
			this.submenuOpened = !this.submenuOpened;
		}
	},

	mounted() {
		// при зміні розміру вікна будем перевіряти, яку меню показувати
		$(window).resize(() => {
			this.isMobile = $(window).width() > 639 ? false : true;

			this.ww = $(window).width();
		})

		$(document).on('click', e => {
			if(!$(e.target).closest('#navigation .extraMenu').length && !$(e.target).closest('.index-top-slider .owl-nav').length) {
				this.submenuOpened = false;
			}
		})
	},

	updated(){
		$('#navigation > ul > li').each(function () {
			let navW = $('#navigation').width();
			if(!$(this).hasClass('extraMenu')){
				if(navW - ($('#navigation')[0].getBoundingClientRect().right - $(this)[0].getBoundingClientRect().right) > 300){
					$(this).find('.menuWrapAbsolut').removeClass('menuPositionLeft');
					$(this).find('.menuWrapAbsolut').addClass('menuPositionRight');
				}else {
					$(this).find('.menuWrapAbsolut').removeClass('menuPositionRight');
					$(this).find('.menuWrapAbsolut').addClass('menuPositionLeft');
				}
			}
		});
		$('.perfectScroll').perfectScrollbar();
		$('#navigation > ul > li:not(".extraMenu")').each(function(element) {
			//console.log($(this).find('.menuWrapAbsolut'));
			if($(this).children('.menuWrapAbsolut').length) {
				$(this).children('.menuWrapAbsolut');
				$(this).children('.menuWrapAbsolut').siblings('a').addClass('active-arrow');
			}
		})
	}
}
</script>

<style lang="scss">
@import "scss/wanted";

.global-navigation-container.top {
	display: flex;
	justify-content: flex-end;
	// position: relative;
}

nav#navigation {
	// background-color: rgba(red, .2);
	width: 100%;
	text-align: right;

	.mobile-opener {
		display: flex;
		align-items: center;
		z-index: 1;
		cursor: pointer;
		position: relative;
		border-radius: rem(4);
		@include single-transition;
		width: 100%;
		height: 55px;
		list-style-type: none;
		margin: 0px;
		margin-bottom: 0px;
		justify-content: space-between;
		margin-bottom: 2px;
		padding: 0 5px 0 15px;
		flex-direction: row;
		background-color: var(--bg-color);
		&:hover{
			background-color: var(--bg-hover);
		}
		@include m_up {
			display: none;
		};

		&.active {
			.lines {
				@include translateX(2px);

				span {
					&:before {
						// background-color: #263C46;
					}

					&.one {
						@include transform(rotate(45deg) translateX(2px) translateY(5px));
					}

					&.two {
						opacity: 0;
					}

					&.three {
						@include transform(rotate(-45deg) translateX(2px) translateY(-5px));
					}
				}
			}
		}

		.word {
			flex: 1 1 auto;
			letter-spacing: normal;
			text-align: left;
			display: block;
			font-style: normal;
			font-family: "ProximaNova-Bold";
			color: #fff;
			font-size: 14px;
			// @include s_up {
			// 	display: none;
			// };
			// @include m_up {
			// };
		}

		.lines {
			@include flexbox;
			@include align-items(center);
			@include align-content(center);
			@include justify-content(center);
			@include flex-wrap(wrap);
			width: rem(40);
			height: rem(34);
			@include single-transition;

			span {
				display: block;
				width: 100%;
				height: 2px;
				margin: 0 0 3px;
				position: relative;
				@include single-transition;

				&:before {
					content: '';
					display: inline-block;
					height: 2px;
					width: rem(18);
					background-color: #fff;
					@include m_up{
						background-color: #6E7175;
					};
					position: absolute;
					top: 0;
					left: calc(50% - #{rem(18/2)});
				}

				&:last-child {
					margin: 0;
				}
			}
		}
	}

	.overlay {
		display: none;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(#000, .95);
		z-index: 3;
		width: 100%;
		opacity: 0;
		pointer-events: none;
		touch-action: none;
		transition: opacity 400ms ease 0ms;

		&.visible {
			opacity: 1;
			pointer-events: auto;
			touch-action: auto;
		}
	}



	//бургер 3 точки

	.extraMenu{
		text-align: center;
		position: relative;
		.dropMenu{
			display: flex;
			align-items: center;
			flex-direction: column;
			@include l_up {
				align-items: flex-start;
			}
			@include l___up {
				@include transform (translateX(-40px));
				align-items: flex-start;
			}
			svg{
				display: inline-block;
				margin-bottom: 3px;
				margin-top: -1px;
				stroke: #333333;
				cursor: pointer;
				line{
					-webkit-transition: all 200ms;
						 -moz-transition: all 200ms;
							 -o-transition: all 200ms;
									transition: all 200ms;
				}
				line:nth-child(2){
					-webkit-transition: all 0ms;
						 -moz-transition: all 0ms;
							 -o-transition: all 0ms;
									transition: all 0ms;
				}
				&.animSVG {
					line:nth-child(1){
						-webkit-transform: translateX(11px) translateY(-6px) rotate(45deg);
						-moz-transform: translateX(11px) translateY(-6px) rotate(45deg);
						-o-transform: translateX(11px) translateY(-6px) rotate(45deg);
						transform: translateX(11px) translateY(-6px) rotate(45deg);
					}
					line:nth-child(2){
						visibility: hidden;
					}
					line:nth-child(3){
						-webkit-transform: translateX(-10px) translateY(7px) rotate(-47deg);
						-moz-transform: translateX(-10px) translateY(7px) rotate(-47deg);
						-o-transform: translateX(-10px) translateY(7px) rotate(-47deg);
						transform: translateX(-10px) translateY(7px) rotate(-47deg);
					}
				}
			}
		}
		ul{
			position: absolute;
			opacity: 0;
			pointer-events: none;
			background-color: white;
			top: 147%;
			padding: 30px;
			right: -10px;
			width: 210px;
			border-radius:5px;
			box-shadow: 0px 0px 10px 2px rgba(52, 78, 96, 0.17);
			background-color: var(--bg-color);
			@include transition(all,300ms,ease,0ms);
			@include transform (scale(0.1) translateY(-300px));
			li{
				color: #ffffff;
				margin-bottom: 29px;
				text-align: left;
				line-height: 10px;
				font-family: $ProximaNova_bold;
				&:nth-last-child(1){
					margin-bottom: 0px;
				}
				& .active{
					// font-family: $Circe_bold;
				}
				a{
					text-decoration: none;
	        color: #fff;
	        font-weight: bold;
	        font-size: 14px;
	        padding: 15px 0px;
				}
			}

			&:before{
				content: "";
				position: absolute;
				right: 0px;
				top: -16px;
				width: 0;
				height: 0;
				border-style: solid;
				border-width: 0 0px 20px 18px;
				border-color: transparent transparent var(--bg-color) transparent;
			}
		}
		.active{
			opacity: 1;
			pointer-events: auto;
			top: 127%;
			@include transform (scale(1) translateY(0px));
			z-index: 5;
		}
		span{
			display: block;
			padding: rem(15) 0;
			text-decoration: none;
			color: white;
			font-size: rem(18);
			letter-spacing: normal;
			cursor: pointer;
		}
	}

	.addArr{
		>span{
			>i{
				position: relative;
				&:before{
					content: '';
					display: block;
					background: url('#{$imgPathSCSS}arrmenu.svg') no-repeat center;
					transform: rotate(90deg);
					position: absolute;
					left: 100%;
					width: rem(19);
					height: rem(20);
					top: calc(50% - 10px);
					background-size: contain;
					@include single-transition;
				}
			}
			// &:hover{
			// 	i{
			// 		&:before{
			// 			transform: rotate(270deg);
			// 			@include single-transition;
			// 		}
			// 	}
			// }
		}
	}

// первый уровень
	>	ul {
			margin-left: 0px;
			@media (max-width: 639px) {
				width: 300px;
				display: flex;
				justify-content: space-between;
				flex-direction: column;
				position: absolute;
				z-index: 4;
				background-color: white;
				transform: translateY(10px);
				opacity: 0;
				pointer-events: none;
				touch-action: none;
				transition: all 300ms ease 0ms;
				left: 15px;
				right: 0;
				top: 100%;
				box-shadow: 0 10px 20px 0 rgba(#000, .5);
				border-top-width: 4px;
				border-top-style: solid;
			}

			@include m_up {
				display: flex;
				border-top: 1px solid #EBEBEC;
				padding: rem(2) 0 7px;
				height: 55px;
				align-items: center;
				justify-content: space-between;
			};
			&.visible {
				@media (max-width: 639px) {
					transform: translateY(0px);
					opacity: 1;
					pointer-events: auto;
					touch-action: auto;
					width: calc(100% - 30px);
				}
			}
			.backM{
				color: #333333;
				text-align: left;
				font-size: rem(14);
				line-height: 1;
				padding: 15px 30px 6px 45px;
				cursor: pointer;
				position: relative;
				text-transform: capitalize;
				&:before{
					position: absolute;
					left: 30px;
					top: calc(50% - 4px);
					background-image: url('../img/arrmenu.svg');
					width: 15px;
					height: 15px;
					content: "";
					background-size: 15px;
					transform: rotate(180deg);
					@include single-transition();
				}
				&:hover{
					&:before{
						left: 27px;
					}
				}
			}
			> li:not(.extraMenu) {
				text-align: center;
				display: inline-flex;
				@include m_up{
					position: relative;
				};
				@media (max-width: 639px) {
					border-bottom: 1px solid #202020;
					flex-direction: column;
				}

				&:hover {
					> span, .active-arrow {
						> i {
							text-decoration: none;
							&:before {
								@include m_up {
									@include rotate(270deg);
								};
							}
						}
					}
				}

				> span, .active-arrow {
					position: relative;
					&.opened {
						> i {
							&:before {
								@include rotate(270deg);
							}
						}
					}

					> i {
						color: #333333;
						font-weight: bold;
						font-size: 14px;
						pointer-events: none;
						&:before {
							@media (max-width: 639px) {
								@include pointer-events(none);
								@include fa($fa-chevron-down);
								display: block;
								position: absolute;
								font-size: rem(10);
								left: calc(100% + 5px);
								top: calc(50% - 8px);
							}
							@include m_up {
								content: '';
								display: block;
								background: url('#{$imgPathSCSS}arrmenu.svg') no-repeat center;
								transform: rotate(90deg);
								position: absolute;
								left: 100%;
								width: rem(22);
								height: rem(24);
								top: calc(50% - 12px);
								@include single-transition;
							};
						}
					}
				}

				> a, > span {
					display: block;
					padding: rem(15) 0;
					text-decoration: none;
					color: white;
					font-size: rem(18);
					letter-spacing: normal;
					cursor: pointer;
					@include single-transition;
					@include m_up {
						color: #303339;
						font-size: rem(18);
						letter-spacing: normal;
					};
					@include l_up {
						letter-spacing: normal;
						font-size: rem(18);
					};

					&.active {
						> i {
							&:after {
								opacity: 1;
							}
						}
					}

					> i {
						display: inline-block;
						position: relative;
						font-style: normal;
						color: #333333;
						font-weight: bold;
						font-size: 14px;
						pointer-events: none;
						// @media (max-width: 639px) {
						// 	@include pointer-events(none);
						// }
					}
				}

				// level 2
			.menuWrapAbsolut{
				width: 300px;
				z-index: 6;
				background-color: white;
				opacity: 0;
				pointer-events: none;
				transition: all 200ms ease 0ms;
				transform: translateY(10px);
				position: absolute;
				top: 0;
				border-top-color: var(--bg-color);
				@media (max-width: 639px) {
					height: 100%;
					transform: translateX(-100%);
					width: 100%;
				}
				@include m_up {
					top: 100%;
					height: 325px;
					box-shadow: 0 10px 20px 0 rgba(#000, .5);
					border-bottom-left-radius: 5px;
					border-top-width: 4px;
					border-top-style: solid;
					padding-bottom: 10px;
					/*z-index: 10;*/
					z-index: 1020;
					&.menuPositionRight{
						left: auto;
						right: 0;
						&:before{
							position: absolute;
							top: -18px;
							right: 0;
							border: 7px solid transparent;
							border-bottom-width: 7px;
							border-bottom-style: solid;
							border-bottom-color: var(--bg-color);
							content: "";
							z-index: 2;
						}
					}
					&.menuPositionLeft{
						left: 0;
						right: auto;
						&:before{
							position: absolute;
							top: -18px;
							left: 0;
							border: 7px solid transparent;
							border-bottom-width: 7px;
							border-bottom-style: solid;
							border-bottom-color: var(--bg-color);
							content: "";
							z-index: 2;
						}
					}
				}
				&.visible{
					.menuWrapRelative{
						>ul{
							transform: translateX(0);
						}
					}
				}
				.menuWrapRelative{
					position: relative;
					overflow: auto;
					overflow-x: hidden;
					height: 100%;
					>	ul {
						width: 100%;
						transition: all 200ms ease 0ms;
						padding: 10px 0 25px;
						// height: 100%;
						min-height: 100%;
						@media (max-width: 639px) {
							transform: translateX(-100%);
						}
						@include m_up{
							display: block;
							position: absolute;
							top: 0;
							padding: 30px 0 25px;
						};
						>	li {
							width: 100%;
							@include m_up {
								// position: relative;
							};

							> span {
								&.opened {
									> i {
										&:after {
											@include rotate(90deg);
										}
									}
								}
							}

							> a, > span {
								display: block;
								text-decoration: none;
								letter-spacing: normal;
								transition: all 400ms ease 0ms;
								cursor: pointer;
								padding: 0 30px;
								color: #333333;
								text-align: left;
								font-size: rem(16);
								line-height: rem(36);
								> i {
									display: inline-block;
									font-style: normal;
									position: relative;
									pointer-events: none;
								}
								&:hover, &.active{
									font-family: $ProximaNova_bold;
								}
							}

							// level 3
							.wrLevel3Abs{
								position: absolute;
								top: 0;
								background-color: white;
								width: 100%;
								z-index: 2;
								opacity: 0;
								overflow: hidden;
								pointer-events: none;
								transition: all 400ms ease 0ms;
								transform: translateX(-100%);
								height: 100%;
								@media (max-width: 639px) {
										top: 0;
									ul{
										padding: 10px 0 25px;
									}
								}
								> ul {
									height: 100%;
									> li {
										> a, > span {
											display: block;
											text-decoration: none;
											letter-spacing: normal;
											transition: all 400ms ease 400ms;
											cursor: pointer;
											padding: 0 30px;
											color: #333333;
											text-align: left;
											font-size: rem(16);
											line-height: rem(36);

											> i {
												display: inline-block;
												font-style: normal;
												position: relative;
												pointer-events: none;
											}
											&:hover, &.active{
												font-family: $ProximaNova_bold;
											}
										}

										&.opened {
											.wrLevel4Abs {
												display: block;
											}
										}

										.wrLevel4Abs {
											position: absolute;
											top: 0;
											background-color: white;
											opacity: 0;
											pointer-events: none;
											width: 100%;
											z-index: 3;
											height: 0;
											overflow: hidden;
											transform: translateX(-100px);
											transition: all 400ms ease 300ms;
											> ul{
												@media (max-width: 639px) {
													height: 100%;
													top: 0;
												}
												>li{
													> a, > span {
														display: block;
														text-decoration: none;
														letter-spacing: normal;
														transition: all 400ms ease 0ms;
														cursor: pointer;
														padding: 0 30px;
														color: #333333;
														text-align: left;
														font-size: rem(16);
														line-height: rem(36);

														> i {
															display: inline-block;
															font-style: normal;
															position: relative;
															pointer-events: none;
														}
														&:hover, &.active{
															font-family: $ProximaNova_bold;
														}
													}
											}
											}
											&.visible {
												opacity: 1 !important;
												pointer-events: auto;
												touch-action: auto;
												transform: translateX(0);
												height: 100%;
												transition: all 400ms ease 300ms;
											}
										}
									}
								}
								&.visible {
									transform: translateX(0);
									opacity: 1 !important;
									pointer-events: auto;
									touch-action: auto;
									transition: all 400ms ease 300ms;
								}
							}
						}
					}

					.presentation {
						font-size: rem(10);
						color: #fff;
						text-transform: uppercase;
						letter-spacing: normal;
						border: 1px solid #fff;
						width: rem(100);
						height: rem(41);
						display: flex;
						align-items: center;
						justify-content: center;
						margin: rem(45) auto;
						border-radius: rem(3);
					}

					.phone {
							display: flex;
							color: #fff;
							font-size: rem(14);
							// font-family: $Circe_light;
							align-items: center;
							justify-content: center;
							padding: 0;

							i {
								display: block;
								width: rem(32);
								height: rem(32);
								background: url('#{$imgPathSCSS}phoneW.png') no-repeat center;
								margin: 0 rem(15) 0 0;
							}

							span {
								// font-family: $Circe_regular;
							}
						}
					}
					&.visible {
						transform: translateY(0px);
						opacity: 1 !important;
						pointer-events: auto;
						touch-action: auto;
						transition: all 400ms ease 300ms;
					}
				}
			}
		}
}
</style>



// WEBPACK FOOTER //
// top.vue?58ab62dc